import {SmartComponent} from "smart-component-js";
import GenericModalComponent from "../utils/GenericModalComponent";

class PrizeDetailComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.modal = new GenericModalComponent(this.element.querySelector('.generic-modal'));
        this.rewardid = this.element.dataset.rewardId;
        this.url = `/api/1.0/loyalty/campaign/dlover2025/reward/redeem/reward/` + this.rewardid;
        this.couponSetCode = this.element.dataset.couponSet;
        this.couponBook = `/api/1.0/loyalty/campaign/dlover2025/coupon-set/${this.couponSetCode}/book-next-available`;
        this.couponPdf = `/api/1.0/loyalty/campaign/dlover2025/coupon/${this.rewardid}/pdf`;
        this.prizeCta = this.element.querySelector('.prize-detail__cta.active');
        this.wrapper = this.element.querySelector('.prize-detail');
        this.thankyouPage = this.element.querySelector('.prize-redeemed');
        this.requestInProgress = false;
        this.requiredPoints = this.element.dataset.rewardPoints;
        this.earnedPoints = this.element.dataset.userPoints;

        this.init();
    }

    rewardRequest() {
        $('a.prize-detail__cta').attr('href', '/it/login?urlBack=' + encodeURIComponent(document.location.pathname) + '&regSource=' + encodeURIComponent(document.location.href));

        if (this.prizeCta) {
            this.prizeCta.addEventListener('click', () => {
                this.modal.openModal();
                this.addModalListener();
            })
        }
    }


    addModalListener() {
        this.element.querySelector('.refuse').addEventListener('click', () => this.modal.closeModal());
        this.element.querySelector('.generic-modal__close').addEventListener('click', () => this.modal.closeModal());
        this.element.querySelector('.redeem').addEventListener('click', () => {
            this.modal.closeModal();
            this.redeemReward();
        });
    }


    redeemReward() {
        this.element.classList.add('loading');
        if (!this.requestInProgress) {
            this.requestInProgress = true;

            youserxp.ajax(this.url, {
                method: 'POST',
                auth: true
            }).then(
                (data) => {
                    if (data) {
                        this.requestInProgress = false;
                        this.rewardType = data.body.rewardItem.type
                        if (this.rewardType === 'COUPON') {
                            this.couponLink = data.body.rewardItem.externalId;
                            if (this.couponLink) {
                                window.open(this.couponLink, "_blank", "noopener,noreferrer");
                            }

                        } else {
                            this.wrapper.classList.add('hidden');
                            this.thankyouPage.classList.remove('hidden');
                        }

                        this.element.classList.remove('loading')
                    }
                },
                (err) => {
                    this.element.classList.remove('loading')
                    this.requestInProgress = false;
                }
            );
        }

    }

    manageStepper() {
        this.remainigPoints = this.requiredPoints - this.earnedPoints;
        const progressFill = this.element.querySelector('#progressFill');
        const userIcon = this.element.querySelector('#userIcon');

        // Calculate % width
        const percent = Math.min((this.earnedPoints / this.requiredPoints) * 100, 100);
        progressFill.style.width = `${percent}%`;

        // Move the user icon (subtract half its width to center it)
        const containerWidth = 183;
        const iconWidth = 12;
        const maxOffset = containerWidth - iconWidth;
        const position = (percent / 100) * maxOffset;

        if (userIcon) {
            userIcon.style.left = `${position}px`;
            userIcon.style.top = '50%';
            userIcon.style.transform = 'translateY(-50%)';
        }
    }


    init() {
        this.rewardRequest();
        this.manageStepper();
    }
}

export default PrizeDetailComponent;
